import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  DictionaryField,
  DictionaryFieldFromApi,
} from '../../gk-dynamic-list/services/dictionary/dictionary.model';
import { ApiListResponse } from '../services.model';

@Injectable({
  providedIn: 'root',
})
export class CountryDictionaryService {
  static readonly polandCountryId = 1;
  private dictionary: Observable<DictionaryField[]>;
  constructor(private httpClient: HttpClient) {}

  get(): Observable<DictionaryField[]> {
    if (!this.dictionary) {
      this.dictionary = this.httpClient
        .get<ApiListResponse<DictionaryFieldFromApi>>('/api/emuia/slo/kraj')
        .pipe(
          map((data) =>
            data.Response.map((fieldFromApi) =>
              DictionaryField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary;
  }
}
